import { Link } from 'react-router-dom';
import { useState, useRef } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      formData.delete('company_alt');

      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value.toString());
      });

      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // Response is not JSON
      }

      const serverCode = (parsed as { code?: string }).code;
      const serverMsg = (parsed as { meta?: { message?: string } }).meta?.message
        || (parsed as { message?: string }).message
        || responseText;

      if (response.ok && serverCode === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        setErrorMsg(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查您的网络连接后重试');
    }
  };

  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20artistic%20abstract%20background%20with%20flowing%20ink%20washes%20in%20warm%20coral%20and%20gentle%20amber%20tones%2C%20subtle%20floating%20comic%20speech%20bubbles%20fading%20into%20the%20background%2C%20dreamy%20and%20inviting%20atmosphere%2C%20minimal%20and%20elegant%2C%20smooth%20gradients%2C%20no%20distinct%20objects%2C%20pure%20atmospheric%20art&width=1920&height=600&seq=cta-bg-manhwa&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-primary-900/80"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          订阅更新通知
        </h2>
        <p className="text-sm text-white/70 mb-8">
          第一时间获取最新韩漫更新和热门推荐，精彩不错过
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-white bg-white/10 rounded-full px-6 py-3">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            <span className="text-sm">订阅成功！感谢您的关注</span>
          </div>
        ) : (
          <form
            ref={formRef}
            onSubmit={handleSubmit}
            action="https://readdy.ai/api/form/d9pbp8aftmtnfcfh0k3g"
            method="POST"
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            data-readdy-form="true"
          >
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <div className="relative flex-1 w-full">
              <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                className="w-full pl-10 pr-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-white/40 transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-accent-500 text-background-50 font-medium rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-sm cursor-pointer disabled:opacity-50"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-300">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}